import React from 'react';
import { PracticeButton } from './PflegePracticeButton';

/* Tab B5 – Grundgrammatik A1.1 */
export const TabGrammatik = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Grundgrammatik A1.1</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Basic Grammar · <span className="ar">قواعد اللغة الأساسية</span></p>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">📝</span>
        <h3>Pronomen & sein / haben · <span className="ar">الضمائر وأفعال الكينونة</span></h3>
      </div>
      <div className="pflege-card-body">
        <div className="grammar-box">
          <h4>Personalpronomen · Personal Pronouns · <span className="ar">الضمائر الشخصية</span></h4>
          <table className="grammar-table">
            <thead><tr><th>Pronomen</th><th>English</th><th className="ar">عربي</th><th>Beispiel</th></tr></thead>
            <tbody>
              <tr><td className="em">ich</td><td>I</td><td className="ar">أنا</td><td>Ich bin Pflegerin.</td></tr>
              <tr><td className="em">du</td><td>you (informal)</td><td className="ar">أنت (غير رسمي)</td><td>Du bist krank.</td></tr>
              <tr><td className="em">er / sie / es</td><td>he / she / it</td><td className="ar">هو / هي / هو</td><td>Er schläft.</td></tr>
              <tr><td className="em">wir</td><td>we</td><td className="ar">نحن</td><td>Wir helfen Ihnen.</td></tr>
              <tr><td className="em">Sie (formal)</td><td>you (formal)</td><td className="ar">أنت (رسمي)</td><td>Wie geht es Ihnen?</td></tr>
              <tr><td className="em">sie (Plural)</td><td>they</td><td className="ar">هم</td><td>Sie sind Patienten.</td></tr>
            </tbody>
          </table>
        </div>

        <div className="grammar-box">
          <h4>„sein" (to be · <span className="ar">يكون</span>)</h4>
          <table className="grammar-table">
            <thead><tr><th>Pronomen</th><th>Form</th><th>Beispiel</th><th className="ar">عربي</th></tr></thead>
            <tbody>
              <tr><td>ich</td><td className="em">bin</td><td>Ich bin Pfleger.</td><td className="ar">أنا ممرض.</td></tr>
              <tr><td>du</td><td className="em">bist</td><td>Du bist krank.</td><td className="ar">أنت مريض.</td></tr>
              <tr><td>er/sie/es</td><td className="em">ist</td><td>Er ist müde.</td><td className="ar">هو متعب.</td></tr>
              <tr><td>wir</td><td className="em">sind</td><td>Wir sind hier.</td><td className="ar">نحن هنا.</td></tr>
              <tr><td>Sie / sie</td><td className="em">sind</td><td>Sie sind bereit.</td><td className="ar">أنتم / هم مستعدون.</td></tr>
            </tbody>
          </table>
        </div>

        <div className="grammar-box">
          <h4>„haben" (to have · <span className="ar">لديه / يملك</span>)</h4>
          <table className="grammar-table">
            <thead><tr><th>Pronomen</th><th>Form</th><th>Beispiel</th><th className="ar">عربي</th></tr></thead>
            <tbody>
              <tr><td>ich</td><td className="em">habe</td><td>Ich habe Schmerzen.</td><td className="ar">أنا أتألم.</td></tr>
              <tr><td>du</td><td className="em">hast</td><td>Du hast Fieber.</td><td className="ar">لديك حمى.</td></tr>
              <tr><td>er/sie/es</td><td className="em">hat</td><td>Er hat Hunger.</td><td className="ar">هو جائع.</td></tr>
              <tr><td>wir</td><td className="em">haben</td><td>Wir haben Zeit.</td><td className="ar">لدينا وقت.</td></tr>
              <tr><td>Sie / sie</td><td className="em">haben</td><td>Haben Sie Schmerzen?</td><td className="ar">هل لديك ألم؟</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">🔤</span>
        <h3>Artikel (der/die/das) · Articles · <span className="ar">أدوات التعريف</span></h3>
      </div>
      <div className="pflege-card-body">
        <div className="grammar-box">
          <h4>Bestimmte Artikel · Definite Articles · <span className="ar">أدوات التعريف</span></h4>
          <table className="grammar-table">
            <thead><tr><th>Genus</th><th>Artikel</th><th>Beispiel</th><th className="ar">عربي</th></tr></thead>
            <tbody>
              <tr><td>Maskulinum (m)</td><td className="em">der</td><td>der Arzt, der Arm</td><td className="ar">مذكر</td></tr>
              <tr><td>Femininum (f)</td><td className="em">die</td><td>die Hand, die Ärztin</td><td className="ar">مؤنث</td></tr>
              <tr><td>Neutrum (n)</td><td className="em">das</td><td>das Bett, das Knie</td><td className="ar">محايد</td></tr>
              <tr><td>Plural</td><td className="em">die</td><td>die Patienten</td><td className="ar">الجمع</td></tr>
            </tbody>
          </table>
        </div>
        <div className="tip-box">
          <strong>Lerntipp · <span className="ar">نصيحة</span></strong><br/>
          Lernen Sie jedes Wort MIT Artikel: nicht „Arm", sondern <em>„der Arm"</em>! · Learn every word WITH its article! · <span className="ar">تعلم كل كلمة مع أداة التعريف!</span>
        </div>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">❓</span>
        <h3>Fragewörter · Question Words · <span className="ar">أدوات الاستفهام</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Beispiel</th></tr></thead>
          <tbody>
            <tr><td className="de">Was?</td><td className="en">What?</td><td className="ar">ماذا؟</td><td>Was tut weh?</td></tr>
            <tr><td className="de">Wo?</td><td className="en">Where?</td><td className="ar">أين؟</td><td>Wo sind die Schmerzen?</td></tr>
            <tr><td className="de">Wann?</td><td className="en">When?</td><td className="ar">متى؟</td><td>Wann haben Sie gegessen?</td></tr>
            <tr><td className="de">Wie?</td><td className="en">How?</td><td className="ar">كيف؟</td><td>Wie geht es Ihnen?</td></tr>
            <tr><td className="de">Wer?</td><td className="en">Who?</td><td className="ar">من؟</td><td>Wer ist Ihr Arzt?</td></tr>
            <tr><td className="de">Wie viel/viele?</td><td className="en">How much/many?</td><td className="ar">كم؟</td><td>Wie viele Tabletten?</td></tr>
            <tr><td className="de">Warum?</td><td className="en">Why?</td><td className="ar">لماذا؟</td><td>Warum schlafen Sie nicht?</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

/* Tab B6 – Typische Dialoge */
const DIALOGE_DATA = [
  {
    title: 'Dialog 1 – Morgenrunde · Morning Round · الجولة الصباحية',
    lines: [
      { speaker: 'Pflege', de: 'Guten Morgen, Herr Müller! Wie geht es Ihnen heute?', en: 'Good morning, Mr. Müller! How are you today?', ar: 'صباح الخير يا السيد مولر! كيف حالك اليوم؟' },
      { speaker: 'Patient', de: 'Guten Morgen. Nicht so gut. Ich habe Kopfschmerzen.', en: 'Good morning. Not so good. I have a headache.', ar: 'صباح الخير. ليس جيداً. لدي صداع.' },
      { speaker: 'Pflege', de: 'Wie stark sind die Schmerzen? Von 0 bis 10?', en: 'How strong is the pain? From 0 to 10?', ar: 'ما شدة الألم؟ من 0 إلى 10؟' },
      { speaker: 'Patient', de: 'Ungefähr vier.', en: 'About a four.', ar: 'حوالي أربعة.' },
      { speaker: 'Pflege', de: 'Ich bringe Ihnen eine Tablette. Einen Moment bitte.', en: "I'll bring you a tablet. One moment please.", ar: 'سأحضر لك حبة دواء. لحظة من فضلك.' },
    ]
  },
  {
    title: 'Dialog 2 – Vitalzeichen · Vital Signs · العلامات الحيوية',
    lines: [
      { speaker: 'Pflege', de: 'Guten Tag, Frau Schmidt. Ich messe jetzt Ihren Blutdruck. Ist das okay?', en: "Good afternoon. I'll measure your blood pressure now. Is that okay?", ar: 'مرحباً يا السيدة شميت. سأقيس ضغط دمك الآن. هل هذا مناسب؟' },
      { speaker: 'Patient', de: 'Ja, natürlich.', en: 'Yes, of course.', ar: 'نعم، بالطبع.' },
      { speaker: 'Pflege', de: 'Bitte den Arm gerade halten. Danke. … Der Blutdruck ist normal.', en: 'Hold your arm straight please. Thank you. … Blood pressure is normal.', ar: 'أمسك ذراعك بشكل مستقيم. شكراً. … ضغط الدم طبيعي.' },
      { speaker: 'Patient', de: 'Gut, danke.', en: 'Good, thank you.', ar: 'جيد، شكراً.' },
    ]
  },
  {
    title: 'Dialog 3 – Medikamente · Medication · الدواء',
    lines: [
      { speaker: 'Pflege', de: 'Herr Weber, hier sind Ihre Tabletten für heute Morgen.', en: 'Mr. Weber, here are your tablets for this morning.', ar: 'السيد ويبر، هذه حبوب دوائك لهذا الصباح.' },
      { speaker: 'Patient', de: 'Wie viele Tabletten sind das?', en: 'How many tablets are there?', ar: 'كم عدد الحبوب؟' },
      { speaker: 'Pflege', de: 'Drei. Eine für den Blutdruck, eine gegen Schmerzen, eine für den Magen.', en: 'Three. One for blood pressure, one for pain, one for the stomach.', ar: 'ثلاث حبوب. للضغط، للألم، وللمعدة.' },
      { speaker: 'Patient', de: 'Ich bin allergisch gegen Aspirin.', en: 'I am allergic to Aspirin.', ar: 'أنا حساس من الأسبرين.' },
      { speaker: 'Pflege', de: "Das ist kein Aspirin. Aber ich frage nochmal den Arzt. Einen Moment bitte!", en: "That is not Aspirin. But I'll check with the doctor again. One moment!", ar: 'هذا ليس أسبريناً. لكنني سأتأكد مع الطبيب. لحظة!' },
    ]
  },
  {
    title: 'Dialog 4 – Notfall · Emergency · حالة طارئة',
    lines: [
      { speaker: 'Patient', de: 'Hilfe! Ich fühle mich sehr schlecht. Mir ist schwindelig!', en: 'Help! I feel very unwell. I am dizzy!', ar: 'مساعدة! أشعر بتعب شديد. أنا أعاني من دوار!' },
      { speaker: 'Pflege', de: 'Bleiben Sie ruhig! Legen Sie sich hin. Atmen Sie tief.', en: 'Stay calm! Lie down. Breathe deeply.', ar: 'ابق هادئاً! استلق. تنفس بعمق.' },
      { speaker: 'Patient', de: 'Meine Brust tut auch weh.', en: 'My chest also hurts.', ar: 'صدري يؤلمني أيضاً.' },
      { speaker: 'Pflege', de: 'Ich rufe sofort den Arzt! Haben Sie Schmerzen links?', en: "I'll call the doctor immediately! Do you have pain on the left?", ar: 'سأستدعي الطبيب فوراً! هل يؤلمك الجانب الأيسر؟' },
      { speaker: 'Patient', de: 'Ja, hier – links.', en: 'Yes, here – on the left.', ar: 'نعم، هنا – على اليسار.' },
      { speaker: 'Pflege', de: 'Ich bin bei Ihnen. Der Arzt kommt gleich. Bleiben Sie ruhig!', en: 'I am with you. The doctor is coming. Stay calm!', ar: 'أنا معك. الطبيب قادم. ابق هادئاً!' },
    ]
  },
];

export const TabDialoge = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Typische Dialoge</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>8 Dialogues · <span className="ar">8 حوارات نموذجية</span></p>

    {DIALOGE_DATA.map((dialog, i) => (
      <div key={`dialog-${i}`} className="dialog-box">
        <div className="dialog-title">{dialog.title}</div>
        <div className="dialog-content">
          {dialog.lines.map((line, j) => (
            <div key={`pdl-${line.speaker}-${j}`} className="dialog-line">
              <div className={`dialog-speaker ${line.speaker.toLowerCase()}`}>{line.speaker}:</div>
              <div className={`dialog-bubble ${line.speaker === 'Patient' ? 'patient' : ''}`}>
                <div className="de">{line.de}</div>
                <div className="en">{line.en}</div>
                <div className="ar">{line.ar}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}

    <div className="tip-box" style={{marginTop: '20px'}}>
      <strong>Rollenspiel-Tipp · Role Play · <span className="ar">لعب الأدوار</span></strong><br/>
      Üben Sie mit einem Kollegen: Eine Person = Pflegekraft, eine = Patient. Dann Rollen tauschen! · Practice with a colleague: one = nurse, one = patient. Then switch roles! · <span className="ar">تدرب مع زميل: شخص ممرض وآخر مريض. ثم تبادل الأدوار!</span>
    </div>
  </div>
);

/* Tab B7 – Erweiterter Wortschatz */
const WORTSCHATZ_SECTIONS = [
  {
    icon: '🏥', titleDe: 'Im Krankenhaus', titleEn: 'In the Hospital', titleAr: 'في المستشفى',
    items: [
      { de: 'die Station', en: 'ward/unit', ar: 'الجناح' },
      { de: 'das Zimmer', en: 'room', ar: 'الغرفة' },
      { de: 'die Notaufnahme', en: 'emergency room', ar: 'غرفة الطوارئ' },
      { de: 'die Intensivstation', en: 'intensive care unit', ar: 'العناية المركزة' },
      { de: 'der Operationssaal', en: 'operating room', ar: 'غرفة العمليات' },
      { de: 'die Apotheke', en: 'pharmacy', ar: 'الصيدلية' },
      { de: 'das Labor', en: 'laboratory', ar: 'المختبر' },
      { de: 'die Röntgenabteilung', en: 'X-ray department', ar: 'قسم الأشعة' },
      { de: 'der Wartebereich', en: 'waiting area', ar: 'منطقة الانتظار' },
      { de: 'die Besuchszeit', en: 'visiting hours', ar: 'ساعات الزيارة' },
    ]
  },
  {
    icon: '💊', titleDe: 'Medikamente & Behandlung', titleEn: 'Medication & Treatment', titleAr: 'الأدوية والعلاج',
    items: [
      { de: 'die Salbe', en: 'ointment', ar: 'مرهم' },
      { de: 'die Tropfen', en: 'drops', ar: 'قطرات' },
      { de: 'der Sirup', en: 'syrup', ar: 'شراب' },
      { de: 'die Kapsel', en: 'capsule', ar: 'كبسولة' },
      { de: 'das Pflaster', en: 'plaster/bandaid', ar: 'لاصقة طبية' },
      { de: 'die Kompresse', en: 'compress', ar: 'كمادة' },
      { de: 'das Desinfektionsmittel', en: 'disinfectant', ar: 'مطهر' },
      { de: 'die Blutentnahme', en: 'blood draw', ar: 'سحب الدم' },
      { de: 'die Untersuchung', en: 'examination', ar: 'الفحص' },
      { de: 'die Behandlung', en: 'treatment', ar: 'العلاج' },
      { de: 'die Operation', en: 'surgery', ar: 'العملية الجراحية' },
      { de: 'die Therapie', en: 'therapy', ar: 'العلاج الطبيعي' },
    ]
  },
  {
    icon: '🍽️', titleDe: 'Essen & Trinken', titleEn: 'Food & Drink', titleAr: 'الطعام والشراب',
    items: [
      { de: 'das Frühstück', en: 'breakfast', ar: 'الفطور' },
      { de: 'das Mittagessen', en: 'lunch', ar: 'الغداء' },
      { de: 'das Abendessen', en: 'dinner', ar: 'العشاء' },
      { de: 'das Wasser', en: 'water', ar: 'الماء' },
      { de: 'der Tee', en: 'tea', ar: 'الشاي' },
      { de: 'der Saft', en: 'juice', ar: 'العصير' },
      { de: 'das Brot', en: 'bread', ar: 'الخبز' },
      { de: 'die Suppe', en: 'soup', ar: 'الحساء' },
      { de: 'der Joghurt', en: 'yogurt', ar: 'الزبادي' },
      { de: 'die Diät', en: 'diet', ar: 'الحمية' },
      { de: 'nüchtern', en: 'fasting/empty stomach', ar: 'صائم' },
      { de: 'die Allergie', en: 'allergy', ar: 'حساسية' },
    ]
  },
  {
    icon: '😷', titleDe: 'Krankheiten & Symptome', titleEn: 'Illnesses & Symptoms', titleAr: 'الأمراض والأعراض',
    items: [
      { de: 'die Grippe', en: 'flu', ar: 'الأنفلونزا' },
      { de: 'die Erkältung', en: 'cold', ar: 'نزلة برد' },
      { de: 'der Husten', en: 'cough', ar: 'السعال' },
      { de: 'der Schnupfen', en: 'runny nose', ar: 'الزكام' },
      { de: 'die Entzündung', en: 'inflammation', ar: 'التهاب' },
      { de: 'die Infektion', en: 'infection', ar: 'عدوى' },
      { de: 'der Diabetes', en: 'diabetes', ar: 'السكري' },
      { de: 'der Bluthochdruck', en: 'high blood pressure', ar: 'ارتفاع ضغط الدم' },
      { de: 'die Verstopfung', en: 'constipation', ar: 'الإمساك' },
      { de: 'der Durchfall', en: 'diarrhea', ar: 'الإسهال' },
      { de: 'das Erbrechen', en: 'vomiting', ar: 'القيء' },
      { de: 'der Ausschlag', en: 'rash', ar: 'طفح جلدي' },
    ]
  },
  {
    icon: '🧹', titleDe: 'Hygiene & Körperpflege', titleEn: 'Hygiene & Personal Care', titleAr: 'النظافة والعناية الشخصية',
    items: [
      { de: 'waschen', en: 'to wash', ar: 'يغسل' },
      { de: 'duschen', en: 'to shower', ar: 'يستحم' },
      { de: 'baden', en: 'to bathe', ar: 'يستحم (في حوض)' },
      { de: 'die Zahnbürste', en: 'toothbrush', ar: 'فرشاة أسنان' },
      { de: 'die Seife', en: 'soap', ar: 'صابون' },
      { de: 'das Handtuch', en: 'towel', ar: 'منشفة' },
      { de: 'der Kamm', en: 'comb', ar: 'مشط' },
      { de: 'die Windel', en: 'diaper', ar: 'حفاضة' },
      { de: 'die Bettdecke', en: 'blanket', ar: 'غطاء السرير' },
      { de: 'das Kissen', en: 'pillow', ar: 'وسادة' },
    ]
  },
  {
    icon: '🗓️', titleDe: 'Wochentage & Monate', titleEn: 'Days & Months', titleAr: 'الأيام والأشهر',
    isCalendar: true,
  }
];

export const TabWortschatz = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Erweiterter Wortschatz A1</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Extended Vocabulary · <span className="ar">مفردات موسعة</span></p>

    {WORTSCHATZ_SECTIONS.map((section, si) => {
      if (section.isCalendar) {
        return (
          <div key={`ws-cal-${si}`} className="pflege-card">
            <div className="pflege-card-header">
              <span className="pflege-card-icon">{section.icon}</span>
              <h3>{section.titleDe} · {section.titleEn} · <span className="ar">{section.titleAr}</span></h3>
            </div>
            <div className="pflege-card-body">
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px'}}>
                <div>
                  <h4 style={{color: '#14b8a6', marginBottom: '8px', fontSize: '14px'}}>Wochentage · Days</h4>
                  {['Montag|Monday|الإثنين','Dienstag|Tuesday|الثلاثاء','Mittwoch|Wednesday|الأربعاء','Donnerstag|Thursday|الخميس','Freitag|Friday|الجمعة','Samstag|Saturday|السبت','Sonntag|Sunday|الأحد'].map((d, i) => {
                    const [de, en] = d.split('|');
                    return (
                      <div key={`day-${de}`} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #334155'}}>
                        <span><strong style={{color: '#f1f5f9'}}>{de}</strong> <span style={{color: '#94a3b8', fontSize: '12px'}}>({en})</span></span>
                        <PracticeButton text={de} />
                      </div>
                    );
                  })}
                </div>
                <div>
                  <h4 style={{color: '#14b8a6', marginBottom: '8px', fontSize: '14px'}}>Monate · Months</h4>
                  {['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'].map((de) => (
                    <div key={`month-${de}`} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #334155'}}>
                      <span><strong style={{color: '#f1f5f9'}}>{de}</strong></span>
                      <PracticeButton text={de} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      }

      return (
        <div key={`ws-${si}`} className="pflege-card">
          <div className="pflege-card-header">
            <span className="pflege-card-icon">{section.icon}</span>
            <h3>{section.titleDe} · {section.titleEn} · <span className="ar">{section.titleAr}</span></h3>
          </div>
          <div className="pflege-card-body">
            <table className="vocab-table">
              <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
              <tbody>
                {section.items.map((item, i) => (
                  <tr key={`ws-${si}-${item.de.slice(0,8)}-${i}`}>
                    <td className="de">{item.de}</td>
                    <td className="en">{item.en}</td>
                    <td className="ar">{item.ar}</td>
                    <td><PracticeButton text={item.de} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    })}
  </div>
);

/* Tab B8 – Notfallsituationen */
const NOTFALL_DIALOGS = [
  {
    title: 'Dialog: Herzprobleme · Heart Problems · مشاكل القلب',
    lines: [
      { speaker: 'Patient', de: 'Hilfe! Meine Brust tut sehr weh!', en: 'Help! My chest hurts a lot!', ar: 'مساعدة! صدري يؤلمني جداً!' },
      { speaker: 'Pflege', de: 'Bleiben Sie ruhig! Setzen Sie sich hin. Wo genau ist der Schmerz?', en: 'Stay calm! Sit down. Where exactly is the pain?', ar: 'ابق هادئاً! اجلس. أين بالضبط الألم؟' },
      { speaker: 'Patient', de: 'Hier, links. Der Schmerz geht in den Arm.', en: 'Here, on the left. The pain goes to my arm.', ar: 'هنا، على اليسار. الألم يمتد إلى ذراعي.' },
      { speaker: 'Pflege', de: 'Ich rufe sofort den Notarzt! Haben Sie Atemnot?', en: "I'll call emergency right away! Do you have shortness of breath?", ar: 'سأتصل بالطوارئ فوراً! هل لديك ضيق في التنفس؟' },
      { speaker: 'Patient', de: 'Ja, ich kann nicht richtig atmen.', en: "Yes, I can't breathe properly.", ar: 'نعم، لا أستطيع التنفس بشكل صحيح.' },
      { speaker: 'Pflege', de: 'Nehmen Sie Herzmedikamente? Nitrospray?', en: 'Do you take heart medication? Nitro spray?', ar: 'هل تتناول أدوية للقلب؟ بخاخ نيترو؟' },
    ]
  },
  {
    title: 'Dialog: Sturz · Fall · السقوط',
    lines: [
      { speaker: 'Pflege', de: 'Was ist passiert? Sind Sie gestürzt?', en: 'What happened? Did you fall?', ar: 'ماذا حدث؟ هل سقطت؟' },
      { speaker: 'Patient', de: 'Ja, ich bin im Bad ausgerutscht.', en: 'Yes, I slipped in the bathroom.', ar: 'نعم، انزلقت في الحمام.' },
      { speaker: 'Pflege', de: 'Können Sie sich bewegen? Wo haben Sie Schmerzen?', en: 'Can you move? Where do you have pain?', ar: 'هل تستطيع التحرك؟ أين يؤلمك؟' },
      { speaker: 'Patient', de: 'Mein Bein tut weh. Ich kann nicht aufstehen.', en: "My leg hurts. I can't get up.", ar: 'رجلي تؤلمني. لا أستطيع النهوض.' },
      { speaker: 'Pflege', de: 'Bewegen Sie sich nicht! Ich hole Hilfe. Haben Sie Ihren Kopf angeschlagen?', en: "Don't move! I'll get help. Did you hit your head?", ar: 'لا تتحرك! سأحضر المساعدة. هل ارتطم رأسك؟' },
    ]
  },
  {
    title: 'Dialog: Atemnot · Breathing Difficulty · ضيق التنفس',
    lines: [
      { speaker: 'Patient', de: 'Ich bekomme keine Luft!', en: "I can't get air!", ar: 'لا أستطيع التنفس!' },
      { speaker: 'Pflege', de: 'Ich bin hier. Setzen Sie sich aufrecht hin.', en: 'I am here. Sit upright.', ar: 'أنا هنا. اجلس بشكل مستقيم.' },
      { speaker: 'Pflege', de: 'Atmen Sie langsam. Ein... und aus...', en: 'Breathe slowly. In... and out...', ar: 'تنفس ببطء. شهيق... وزفير...' },
      { speaker: 'Patient', de: 'Ich habe Angst!', en: 'I am scared!', ar: 'أنا خائف!' },
      { speaker: 'Pflege', de: 'Ich bin bei Ihnen. Der Sauerstoff kommt gleich. Alles wird gut.', en: 'I am with you. Oxygen is coming. Everything will be fine.', ar: 'أنا معك. الأكسجين قادم. كل شيء سيكون بخير.' },
    ]
  },
];

const NOTFALL_VOCAB = [
  { de: 'Hilfe!', en: 'Help!', ar: 'مساعدة!' },
  { de: 'Notfall!', en: 'Emergency!', ar: 'طوارئ!' },
  { de: 'Rufen Sie einen Arzt!', en: 'Call a doctor!', ar: 'اتصل بالطبيب!' },
  { de: 'Rufen Sie den Notarzt!', en: 'Call emergency services!', ar: 'اتصل بالإسعاف!' },
  { de: 'Er/Sie atmet nicht!', en: 'He/She is not breathing!', ar: 'هو/هي لا يتنفس!' },
  { de: 'Er/Sie ist bewusstlos!', en: 'He/She is unconscious!', ar: 'هو/هي فاقد الوعي!' },
  { de: 'Herzstillstand!', en: 'Cardiac arrest!', ar: 'توقف القلب!' },
  { de: 'Schlaganfall!', en: 'Stroke!', ar: 'سكتة دماغية!' },
  { de: 'starke Blutung', en: 'heavy bleeding', ar: 'نزيف حاد' },
  { de: 'allergischer Schock', en: 'allergic shock', ar: 'صدمة حساسية' },
];

const NOTFALL_INSTRUCTIONS = [
  { de: 'Bleiben Sie liegen!', en: 'Stay lying down!', ar: 'ابق مستلقياً!' },
  { de: 'Bewegen Sie sich nicht!', en: "Don't move!", ar: 'لا تتحرك!' },
  { de: 'Atmen Sie tief!', en: 'Breathe deeply!', ar: 'تنفس بعمق!' },
  { de: 'Beruhigen Sie sich!', en: 'Calm down!', ar: 'اهدأ!' },
  { de: 'Halten Sie still!', en: 'Hold still!', ar: 'لا تتحرك!' },
  { de: 'Öffnen Sie die Augen!', en: 'Open your eyes!', ar: 'افتح عينيك!' },
  { de: 'Drücken Sie meine Hand!', en: 'Squeeze my hand!', ar: 'اضغط على يدي!' },
  { de: 'Können Sie mich hören?', en: 'Can you hear me?', ar: 'هل تسمعني؟' },
  { de: 'Hilfe ist unterwegs!', en: 'Help is on the way!', ar: 'المساعدة في الطريق!' },
  { de: 'Ich bleibe bei Ihnen!', en: 'I will stay with you!', ar: 'سأبقى معك!' },
];

export const TabNotfall = ({ isActive }) => (
  <div className={`pflege-section ${isActive ? 'active' : ''}`}>
    <h2 style={{fontSize: '22px', fontWeight: '700', marginBottom: '8px'}}>Notfallsituationen</h2>
    <p style={{color: '#94a3b8', marginBottom: '20px'}}>Emergency Situations · <span className="ar">حالات الطوارئ</span></p>

    <div className="pflege-card" style={{borderColor: '#ef4444', borderWidth: '2px'}}>
      <div className="pflege-card-header" style={{background: 'rgba(239,68,68,0.1)'}}>
        <span className="pflege-card-icon">🚨</span>
        <h3 style={{color: '#ef4444'}}>Notfall-Vokabular · Emergency Vocabulary · <span className="ar">مفردات الطوارئ</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {NOTFALL_VOCAB.map((item, i) => (
              <tr key={`emvoc-${item.de.slice(0,6)}-${i}`}>
                <td className="de" style={{color: '#ef4444', fontWeight: '600'}}>{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">💬</span>
        <h3>Notfall-Dialoge · Emergency Dialogues · <span className="ar">حوارات الطوارئ</span></h3>
      </div>
      <div className="pflege-card-body">
        {NOTFALL_DIALOGS.map((dialog, i) => (
          <div key={`emdlg-${i}`} className="dialog-box" style={{marginBottom: '16px'}}>
            <div className="dialog-title" style={{background: 'rgba(239,68,68,0.1)', color: '#ef4444'}}>{dialog.title}</div>
            <div className="dialog-content">
              {dialog.lines.map((line, j) => (
                <div key={`edl-${line.speaker}-${j}`} className="dialog-line">
                  <div className={`dialog-speaker ${line.speaker.toLowerCase()}`}>{line.speaker}:</div>
                  <div className={`dialog-bubble ${line.speaker === 'Patient' ? 'patient' : ''}`}>
                    <div className="de" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <span>{line.de}</span>
                      <PracticeButton text={line.de} />
                    </div>
                    <div className="en">{line.en}</div>
                    <div className="ar">{line.ar}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="pflege-card">
      <div className="pflege-card-header">
        <span className="pflege-card-icon">📋</span>
        <h3>Notfall-Anweisungen · Emergency Instructions · <span className="ar">تعليمات الطوارئ</span></h3>
      </div>
      <div className="pflege-card-body">
        <table className="vocab-table">
          <thead><tr><th>Deutsch</th><th>English</th><th className="ar">عربي</th><th>Üben</th></tr></thead>
          <tbody>
            {NOTFALL_INSTRUCTIONS.map((item, i) => (
              <tr key={`eminst-${item.de.slice(0,6)}-${i}`}>
                <td className="de">{item.de}</td>
                <td className="en">{item.en}</td>
                <td className="ar">{item.ar}</td>
                <td><PracticeButton text={item.de} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    <div className="tip-box" style={{borderColor: '#ef4444', background: 'rgba(239,68,68,0.1)'}}>
      <strong style={{color: '#ef4444'}}>Wichtig · Important · <span className="ar">مهم</span></strong><br/>
      In Deutschland: Notruf <strong>112</strong> (Rettungsdienst) · In Germany: Emergency <strong>112</strong> · <span className="ar">في ألمانيا: رقم الطوارئ 112</span>
    </div>
  </div>
);
